<template>
  <div class="text-center">
    <h1>404</h1>
    <p>Page Not Found</p>
    <Button
      class="p-button-sm"
      label="Go Home"
      icon="pi pi-caret-left"
      @click="$router.push('/')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    return {};
  }
});
</script>

<style scoped></style>
